module.exports = __webpack_public_path__ + "img/preview.2f206e69.jpg";